import React from "react";
import { Input, Button, Tooltip, Breadcrumb, Select } from "antd"; //new for dropdown
import styles2 from "../imagePicker.module.css";
import {
    SearchOutlined,
    LeftOutlined,
    RightOutlined,
    UploadOutlined,
    CameraOutlined,
    FolderAddOutlined,
    CloseOutlined,
    HomeOutlined,
    FolderOutlined,
} from "@ant-design/icons";

const MobileCollectionActions = ({
    onUpload,
    onCamera,
    onCreateFolder,
    onClose,
}) => {
    return (
        <div style={styles.mobileActions}>
            <Button
                type="primary"
                icon={<UploadOutlined />}
                onClick={onUpload}
                block
                style={{
                    minHeight: 44,
                    flex: 1,
                    backgroundColor: "#43B4AC",
                    borderColor: "#43B4AC",
                }}
            >
                Upload
            </Button>
            <Button
                type="primary"
                icon={<CameraOutlined />}
                onClick={onCamera}
                block
                style={{
                    minHeight: 44,
                    flex: 1,
                    backgroundColor: "#43B4AC",
                    borderColor: "#43B4AC",
                }}
            >
                Camera
            </Button>
        </div>
    );
};

//source options for dropdown
const SOURCE_OPTIONS = [
    { value: "collection", label: "Collection" },
    { value: "unsplash", label: "Unsplash" },
    { value: "pexels", label: "Pexels" },
    { value: "pixabay", label: "Pixabay" },
    { value: "pixabay_png", label: "Pixabay PNG" },
    { value: "gif", label: "GIF" },
    { value: "texture", label: "Texture" },
    { value: "trash", label: "Trash" },
];

function Header({
    isMobile = false,
    activeSource,
    onSourceChange,
    showSearch = true,
    isCollection = false,
    value,
    onChange,
    page,
    totalPages,
    onPageChange,
    onUpload,
    onCamera,
    onCreateFolder,
    onClose,
    folders = [],
    folderStack = [],
    onBreadcrumbClick,
    onFolderClick,
}) {
    return (
        <div style={styles.wrapper}>
            {/*  MOBILE SOURCE DROPDOWN */}
            {isMobile && (
                <div style={{ marginBottom: 8 }}>
                    <Select
                        value={activeSource}
                        options={SOURCE_OPTIONS}
                        onChange={onSourceChange}
                        style={{ width: "100%" }}
                        size="middle"
                    />
                </div>
            )}

            {/* MOBILE COLLECTION ACTIONS */}
            {isMobile && isCollection && (
                <MobileCollectionActions
                    onUpload={onUpload}
                    onCamera={onCamera}
                    onCreateFolder={onCreateFolder}
                    onClose={onClose}
                />
            )}

            {/* ROW 1: Breadcrumb + Action buttons */}
            {isCollection && folderStack.length > 0 && (
                <div style={styles.container}>
                    <div style={styles.left}>
                        <Breadcrumb
                            style={styles.breadcrumb}
                            items={folderStack.map((folder, index) => {
                                const isLast = index === folderStack.length - 1;
                                return {
                                    key: folder.id || "root",
                                    title: (
                                        <span
                                            onClick={() =>
                                                !isLast &&
                                                onBreadcrumbClick?.(index)
                                            }
                                            style={{
                                                cursor: !isLast
                                                    ? "pointer"
                                                    : "default",
                                                color: !isLast
                                                    ? "#1890ff"
                                                    : "inherit",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 4,
                                            }}
                                        >
                                            {index === 0 ? (
                                                <>
                                                    <HomeOutlined />{" "}
                                                    {folder.name}
                                                </>
                                            ) : (
                                                <>
                                                    <FolderOutlined />{" "}
                                                    {folder.name}
                                                </>
                                            )}
                                        </span>
                                    ),
                                };
                            })}
                        />
                    </div>

                    <div style={styles.right}>
                        {!isMobile && (
                            <>
                                <Tooltip title="Upload image">
                                    <Button
                                        type="primary"
                                        icon={<UploadOutlined />}
                                        onClick={onUpload}
                                        style={{
                                            backgroundColor: "#43B4AC",
                                            borderColor: "#43B4AC",
                                        }}
                                    >
                                        Upload
                                    </Button>
                                </Tooltip>

                                <Tooltip title="Take photo">
                                    <Button
                                        type="primary"
                                        icon={<CameraOutlined />}
                                        onClick={onCamera}
                                        style={{
                                            backgroundColor: "#43B4AC",
                                            borderColor: "#43B4AC",
                                        }}
                                    >
                                        Camera
                                    </Button>
                                </Tooltip>

                                <Tooltip title="Close">
                                    <Button
                                        icon={<CloseOutlined />}
                                        onClick={onClose}
                                    />
                                </Tooltip>
                            </>
                        )}
                    </div>
                </div>
            )}

            {/* ROW 2: Folder buttons */}
            {isCollection && (
                <div
                    style={isMobile ? styles.folderRowMobile : styles.folderRow}
                    className={isMobile ? styles2.folderRowMobile : ""}
                >
                    <Button
                        size={isMobile ? "large" : "small"}
                        icon={<FolderAddOutlined />}
                        onClick={onCreateFolder}
                        style={{
                            height: isMobile ? 40 : 32,
                            fontSize: isMobile ? 14 : 12,
                            borderRadius: 8,
                            borderStyle: "dashed",
                            flexShrink: 0,
                        }}
                    >
                        New Folder
                    </Button>
                    {folders.map((folder) => (
                        <Button
                            key={folder.id}
                            size={isMobile ? "large" : "small"}
                            icon={<FolderOutlined />}
                            onClick={() => onFolderClick?.(folder)}
                            style={{
                                height: isMobile ? 40 : 32,
                                fontSize: isMobile ? 14 : 12,
                                borderRadius: 8,
                                color: "#43B4AC",
                                borderColor: "#b7e5e3",
                                backgroundColor: "#f0fafa",
                                fontWeight: 500,
                                flexShrink: 0,
                                transition: "all 0.2s ease",
                            }}
                        >
                            {folder.name}
                        </Button>
                    ))}
                </div>
            )}

            {/* Search + pagination + close — one unified row */}
            {showSearch && !isCollection && (
                <div style={styles.searchRow}>
                    <Input
                        value={value}
                        placeholder="Search images..."
                        onChange={(e) => onChange(e.target.value)}
                        onPressEnter={() => onPageChange(1)}
                        size={isMobile ? "large" : "middle"}
                        style={{
                            borderRadius: 8,
                            height: isMobile ? 40 : "auto",
                            flex: 1,
                        }}
                    />
                    {!isMobile && (
                        <>
                            <Button
                                type="primary"
                                icon={<SearchOutlined />}
                                onClick={() => onPageChange(1)}
                            />
                            {totalPages > 1 && (
                                <>
                                    <Button
                                        icon={<LeftOutlined />}
                                        disabled={page === 1}
                                        onClick={() => onPageChange(page - 1)}
                                    />
                                    <Button
                                        icon={<RightOutlined />}
                                        disabled={page >= totalPages}
                                        onClick={() => onPageChange(page + 1)}
                                    />
                                </>
                            )}
                            <Tooltip title="Close">
                                <Button
                                    icon={<CloseOutlined />}
                                    onClick={onClose}
                                />
                            </Tooltip>
                        </>
                    )}
                </div>
            )}
        </div>
    );
}

const styles = {
    wrapper: {
        display: "flex",
        flexDirection: "column",
        gap: 12,
        padding: "12px 0px",
        borderBottom: "1px solid #f0f0f0",
    },
    container: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 16,
        width: "100%",
    },
    left: {
        flex: 1,
        display: "flex",
        alignItems: "center",
        minWidth: 0,
    },
    folderRow: {
        display: "flex",
        gap: 8,
        flexWrap: "wrap",
        marginBottom: 0,
    },
    folderRowMobile: {
        display: "flex",
        gap: 8,
        flexWrap: "nowrap",
        overflowX: "auto",
        WebkitOverflowScrolling: "touch",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        paddingBottom: "4",
        maxWidth: "100vw",
    },
    breadcrumb: {
        marginBottom: 0,
        fontSize: 13,
    },
    searchRow: {
        display: "flex",
        gap: 8,
        alignItems: "center",
        width: "100%",
    },
    right: {
        marginLeft: "auto",
        display: "flex",
        alignItems: "center",
        gap: 8,
    },
    mobileActions: {
        display: "flex",
        gap: 8,
        marginBottom: 0,
        padding: "4px 0",
    },
};

export default Header;
